export const importSetAdminTranslation = {

  // section title
  manage_import_sets: 9216,

  // search
  search: 7345,
  search_hits: 7474,
  search_no_import_sets: 9221,

  // messages
  no_access_to_import_set_admin: 9222,
  import_set_deleted: 9223,

  // list item
  disabled: 5251,
  delete_import_set_title: 9217,
  delete_import_set_button: 9364,
  duplicate_import_set: 9253,
  import_codes: 9290,

  // confirmation
  delete_confirmation: 9218,
  create: 9246,
  cancel: 9219,

  // prompt unsaved
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  go_back: 7966,

  // form messages
  import_set_created: 9224,
  import_set_updated: 9225,
  import_set_validation_error: 8206,
  saving_import_set: 9227,
  deleting_import_set: 9228,
  fields_are_filled_out_incorrectly: 8206,
  import_code_like_code_info: 9236,
  duplicate_import_set_message: 9252,

  // form header
  new_import_set: 9229,
  import_set: 9234,
  save: 9230,
  add_new: 6943,
  duplicate_title: 9254,

  // form tabs
  switch_to_scroll: 7977,
  switch_to_tab: 7978,

  // sections
  details: 8044,
  descriptions_and_translations: 8391,
  submit: 8940,

  // language
  translations_header: 8364,
  show_translations: 8393,
  description: 7278,
  copy_description_to_all: 8386,
  copied_description_to_all: 8388,

  // fields
  create_empty_import_set: 9231,
  copy_import_set_and_mappings: 9232,
  import_code_like_code: 9233,
  auto_info: 9238,
  import_database_id: 9239,
  criteria_domain: 9240,
  constraint_set: 9241,

  // manage options
  manage_options: 8521,

  // validation
  must_be_filled_out: 5949
};

export type ImportSetAdminTranslation = {
  readonly [T in keyof typeof importSetAdminTranslation]: string
};
